import { NavMarker } from 'react-rhumb';
import FatalError from 'conversations-error-reporting/error-boundaries/components/FatalError';
import { jsx as _jsx } from "react/jsx-runtime";
const FatalTopLevelError = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "INBOX_TOP_LEVEL_FAILURE",
  children: /*#__PURE__*/_jsx(FatalError, {})
});
export default FatalTopLevelError;
FatalTopLevelError.displayName = 'FatalTopLevelError';